import { FC } from 'react';
import { Column, SortColumn, TableHeaderProps } from '../../utils/models';

import css from '../../scss/table.module.scss';

const TableHeader: FC<TableHeaderProps> = (props) => {
	const raiseSort = (path: string): void => {
		const sortColumn: SortColumn = { ...props.sortColumn };

		if (sortColumn.path === path)
			sortColumn.order = sortColumn.order === 'asc' ? 'desc' : 'asc';
		else {
			sortColumn.path = path;
			sortColumn.order = 'asc';
		}

		props.onSort(sortColumn);
	};

	const renderSortIcon = (column: Column): JSX.Element | null => {
		if (column.path !== props.sortColumn.path) return null;

		const order: string = props.sortColumn.order === 'asc' ? 'up' : 'down';
		return <i className={'bi bi-chevron-' + order} />;
	};

	return (
		<thead className={css['table-header']}>
			<tr>
				{props.columns.map((column: Column) => (
					<th
						className="clickable"
						key={column.path || column.key}
						onClick={() => raiseSort(column.path)}
					>
						{column.label} {renderSortIcon(column)}
					</th>
				))}
			</tr>
		</thead>
	);
};

export default TableHeader;
